import { Component } from '@angular/core';

@Component({
  selector: 'app-it',
  templateUrl: './it.component.html',
  styleUrl: './it.component.scss'
})
export class ItComponent {

}
